import { Component,OnInit, ElementRef, ViewChild, Renderer2, HostListener, PLATFORM_ID, Inject  } from '@angular/core';
import * as AOS from 'aos';
import Swiper from 'swiper'; 
import { Title, Meta } from '@angular/platform-browser';
import { Constants } from '../../common/constants';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';

@Component({
  selector: 'app-artificial-intelligence',
  templateUrl: './artificial-intelligence.component.html',
  styleUrls: ['./artificial-intelligence.component.css']
})
export class ArtificialIntelligenceComponent {
  baseUrl = Constants.baseUrl;
  isBrowser:boolean=false;

  constructor(
    private titleService: Title,  @Inject(PLATFORM_ID) private platformId: any,
    private _renderer2: Renderer2,private seoService:SeoService,
    @Inject(DOCUMENT) private _document: Document,

    private metaService: Meta
  ) {this.isBrowser=isPlatformBrowser(this.platformId);}

  ngOnInit(): void {
    let script = this._renderer2.createElement('script');
  script.type = `application/ld+json`;
  script.text = `
{
"@context": "https://schema.org",
"@type": "Article",
"mainEntityOfPage": {
  "@type": "WebPage",
  "@id": "https://mitresource.com/application-services/"
},
"headline": "Application Services",
"description": "Our next-generation application development service empowers some of the world's most successful businesses to streamline complex operations.",
"image": "https://mitresource.com/wp-content/themes/magantiW…ets/images/application/application-bulidimage.png",  
"author": {
  "@type": "Organization",
  "name": "Maganti IT",
  "url": "https://mitresource.com/"
},  
"publisher": {
  "@type": "Organization",
  "name": "Maganti IT",
  "logo": {
    "@type": "ImageObject",
    "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
  }
},
"datePublished": "2024-06-25"
}`;
 
  this._renderer2.appendChild(this._document.head, script);
    if(this.isBrowser){     
  AOS.init({disable: 'mobile'});
}
   
    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();
  }

  scrollToSection(sectionId: string): void {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('Artificial Intelligence & Machine Learning');
    this.metaService.addTags([
      { name: 'description', content: 'Data and analytics aren\'t new. But the level at which they empower customers, markets, and business outcomes has taken a pragmatic shift.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Artificial Intelligence & Machine Learning' },
      { property: 'og:url', content: 'https://mitresource.com/artificial-Intelligence/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/aiimages/scaleyourbusinessimg.png' },
      { property: 'og:description', content: 'Data and analytics aren\'t new. But the level at which they empower customers, markets, and business outcomes has taken a pragmatic shift.' },
    ]);
  }
  brandLogoSlider = {
    slidesToShow: 6,
    slidesToScroll: 1,
    loop: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 1000,
    breakpoints: {
        1499: {
            slidesPerView: 6
        },

        991: {
            slidesPerView: 4
        },

        767: {
            slidesPerView: 3

        },

        575: {
            slidesPerView: 2
        }
    }
};
  swiperBreakpoints = {
    320: { slidesPerView: 1 },      
    768: { slidesPerView: 2 },      
    1024: { slidesPerView: 3 }      
  };
  EmpswiperBreakpoints = {
    320: { slidesPerView: 2},      
    768: { slidesPerView: 4 },      
    1024: { slidesPerView: 6 }      
  };

}
